module.exports = __webpack_public_path__ + "img/kai-new3.29772d1d.png";